import { createContext } from "react";

export const UsageTrackingContext = createContext<((page: string) => void) | null>(null);
